import { useEffect, useState } from "react";
import { CurrentBrand } from "modules/Types";
import { useHistory } from "react-router-dom";
import { TEAM_PLAN_INCLUDED_PRO_ACCOUNTS } from "modules/Const";
import useOrganization from 'Hooks/useOrganization';
import useBrand from 'Hooks/useBrand';
import useUser from 'Hooks/useUser';
import OrganizationNeedsSetupState from "./OrganizationNeedsSetupState";
import PageSymphony from "elements/PageSymphony";
import ContentSymphony from "components/shareable/ContentSymphony";

const AdminOnboarding = () => {
    const history = useHistory()
    const { isSymphonyAdmin } = useUser();
    const { currentBrand } = useBrand()
    const { brandIdIsInOrganization } = useOrganization()

    let initiallyShownBrands: CurrentBrand[] = [];
    if (brandIdIsInOrganization(currentBrand?.id)) {
        initiallyShownBrands = [];
    } else if (currentBrand) {
        initiallyShownBrands = [currentBrand];
    }

    const [defaultBrands, setDefaultBrands] = useState<CurrentBrand[]>(initiallyShownBrands);

    useEffect(() => {
        if (!isSymphonyAdmin) {
            history.push('/')
        }
    }, [isSymphonyAdmin])

    return (
        <PageSymphony
            className="adminOnboardingComponent"
            isContent
            isCard
            maxWidth={750}
        >
            <ContentSymphony
                className="adminOnboardingContent"
            >
                <OrganizationNeedsSetupState
                    title="Admin: Onboard a Team"
                    description={`Create a team on behalf of an organization or profile.\nYou can manage unlimited profiles through your Team, and you have ${TEAM_PLAN_INCLUDED_PRO_ACCOUNTS} Pro accounts included by default.`}
                />
            </ContentSymphony>
        </PageSymphony>
    )
}

export default AdminOnboarding